/*jslint node: true */
'use strict';

import axios from 'axios';

module.exports = {
  getToken: function (cb) {

    axios.get('/stage-ajax/get-token/?cm_lang=fi_FI')
      .then(response => {

        if (cb)
          cb(response.data.token);

      })
      .catch(error => {

        //console.log('error token');

      });

  }
};
